import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error["dark"],
  marginRight: theme.spacing(1),
  borderRadius: "100px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "28px",
  minWidth: "28px"
}))
